'use client';

import { useEffect, useState } from 'react';

import { stopBrowserAnalyticsForObjection } from '@/lib/analytics/client-capture';
import {
  hasAnalyticsOptOutFromDocument,
  setAnalyticsOptOutInDocument,
} from '@/lib/analytics/opt-out';

export default function AnalyticsOptOutButton() {
  const [optedOut, setOptedOut] = useState(false);

  useEffect(() => {
    setOptedOut(hasAnalyticsOptOutFromDocument());
  }, []);

  return (
    <button
      className="hover:text-aareal-aval-light"
      type="button"
      onClick={() => {
        const nextValue = !optedOut;
        setAnalyticsOptOutInDocument(nextValue);
        setOptedOut(nextValue);

        if (nextValue) {
          stopBrowserAnalyticsForObjection();
        }

        window.location.reload();
      }}
    >
      {optedOut ? 'Analyse erlauben' : 'Analyse widersprechen'}
    </button>
  );
}
